import { Button, Grid } from '@material-ui/core';
import React from 'react';
import { Helmet } from "react-helmet";
import icon1 from '../../../assets/images/circus/2024/circo2024_aros.webp';
import icon2 from '../../../assets/images/circus/2024/circo2024_fitas_aereas.webp';
import icon3 from '../../../assets/images/circus/2024/circo2024_funambulismo.webp';
import icon4 from '../../../assets/images/circus/2024/circo2024_hand_ballacing.webp';
import icon5 from '../../../assets/images/circus/2024/circo2024_palhacos.webp';
import icon6 from '../../../assets/images/circus/2024/circo2024_pole_aereo.webp';
import icon7 from '../../../assets/images/circus/2024/circo2024_rollerskating.webp';
import icon8 from '../../../assets/images/circus/2024/circo2024_trapezio_duo.webp';
import logos from '../../../assets/images/circus/2024/logos.png';
import photo1 from '../../../assets/images/circus/2024/photos/Circo2024_01.webp';
import photo2 from '../../../assets/images/circus/2024/photos/Circo2024_02.webp';
import photo3 from '../../../assets/images/circus/2024/photos/Circo2024_03.webp';
import photo4 from '../../../assets/images/circus/2024/photos/Circo2024_04.webp';
import photo5 from '../../../assets/images/circus/2024/photos/Circo2024_05.webp';
import photo6 from '../../../assets/images/circus/2024/photos/Circo2024_06.webp';
import photo7 from '../../../assets/images/circus/2024/photos/Circo2024_07.webp';
import photo8 from '../../../assets/images/circus/2024/photos/Circo2024_08.webp';
import photo9 from '../../../assets/images/circus/2024/photos/Circo2024_09.webp';
import photo10 from '../../../assets/images/circus/2024/photos/Circo2024_10.webp';
import photo11 from '../../../assets/images/circus/2024/photos/Circo2024_11.webp';
import photo12 from '../../../assets/images/circus/2024/photos/Circo2024_12.webp';
import photo13 from '../../../assets/images/circus/2024/photos/Circo2024_13.webp';
import photo14 from '../../../assets/images/circus/2024/photos/Circo2024_14.webp';
import photo15 from '../../../assets/images/circus/2024/photos/Circo2024_15.webp';
import photo16 from '../../../assets/images/circus/2024/photos/Circo2024_16.webp';
import photo17 from '../../../assets/images/circus/2024/photos/Circo2024_17.webp';
import photo18 from '../../../assets/images/circus/2024/photos/Circo2024_18.webp';
import photo19 from '../../../assets/images/circus/2024/photos/Circo2024_19.webp';
import photo20 from '../../../assets/images/circus/2024/photos/Circo2024_20.webp';
import photo21 from '../../../assets/images/circus/2024/photos/Circo2024_21.webp';
import photo22 from '../../../assets/images/circus/2024/photos/Circo2024_22.webp';
import photo23 from '../../../assets/images/circus/2024/photos/Circo2024_23.webp';
import photo24 from '../../../assets/images/circus/2024/photos/Circo2024_24.webp';
import photo25 from '../../../assets/images/circus/2024/photos/Circo2024_25.webp';
import photo26 from '../../../assets/images/circus/2024/photos/Circo2024_26.webp';
import photo27 from '../../../assets/images/circus/2024/photos/Circo2024_27.webp';
import photo28 from '../../../assets/images/circus/2024/photos/Circo2024_28.webp';
import { useGtXs } from '../../../hooks/useGtXs';
import { Config } from '../../../services/Config';
import EventGallery from '../../EventGallery/EventGallery';
import PageTransition from '../../PageTransition/PageTransition';
import Typography from '../../Typography/Typography';
import styles from './Circus2024View.module.scss';
import useGetCircus2024Sessions from './Helpers/useGetCircus2024Sessions';
import Separator from './Separator';
import Session from './Session';

const photos = [
    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6,
    photo7,
    photo8,
    photo9,
    photo10,
    photo11,
    photo12,
    photo13,
    photo14,
    photo15,
    photo16,
    photo17,
    photo18,
    photo19,
    photo20,
    photo21,
    photo22,
    photo23,
    photo24,
    photo25,
    photo26,
    photo27,
    photo28
]

const artists = [
    { id: 1, discipline: "Palhaços", artists: ["Datinelli Brothers"], icon: icon5 },
    { id: 2, discipline: "Aros", artists: ["Priscila Alves"], icon: icon1 },
    { id: 3, discipline: "Trapézio Duo", artists: ["Kimberley Bargenquast", "Flynn Miller"], icon: icon8 },
    { id: 4, discipline: "Roller-Skating", artists: ["Beata Surmiak", "Jamie Swan"], icon: icon7 },
    { id: 5, discipline: "Hand Balancing", artists: ["Duo Jordanella"], icon: icon4 },
    { id: 6, discipline: "Pole Aéreo", artists: ["Mateo Sito"], icon: icon6 },
    { id: 7, discipline: "Funambulismo", artists: ["Los Guerreros"], icon: icon3 },
    { id: 8, discipline: "Fitas Aéreas", artists: ["Augustin Rodriguez", "Beltran"], icon: icon2 },
]

const Artist = (props: any) => {
    const { artist } = props

    const gtXs = useGtXs()
    const disciplineVariant = gtXs ? "RocGroteskRegular25" : "RocGroteskRegular18"
    const nameVariant = gtXs ? "RocGroteskBold25" : "RocGroteskBold16"

    return (
        <Grid item xs={12} md={6} container className={styles.Artist}>
            <div>
                <img src={artist.icon} alt={artist.discipline} />
            </div>
            <div className={styles.ArtistWrapper}>
                <Typography variant={disciplineVariant} component="p">
                    {artist.discipline}
                </Typography>
                <div className={styles.ArtistName}>
                    {artist.artists.map((name: string) =>
                        <Typography variant={nameVariant} component="p">
                            {name}
                        </Typography>
                    )}
                </div>
            </div>
        </Grid>
    )
}


export default function Circus2024View() {

    const { decemberSessions, januarySessions } = useGetCircus2024Sessions()
    const handle = () => {
        window.open("https://ticketline.pt/evento/circo-coliseu-porto-ageas2024-88743")
    }

    return (
        <PageTransition>
            <>
                <Helmet>
                    <meta property="og:site_name" content="Coliseu Porto Ageas" />
                    <meta property="og:url" content={`${Config.APP}circo-2024`} />
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content="Coliseu Porto Ageas" />
                    <meta property="og:description" content="De 13 de dezembro a 5 de janeiro, o Coliseu Porto Ageas apresenta um espetáculo memorável." />
                </Helmet>


                <div className={styles.Hero} />

                <Grid container justify="center" className={styles.Wrapper}>

                    <div className={styles.Circus2024}>

                        <section className={styles.Intro}>


                            <p>
                                De 13 de dezembro a 5 de janeiro, o Coliseu Porto Ageas apresenta um espetáculo memorável, irrepetível e surpreendente, que desvenda o que as artes circenses têm
                                de mais fantástico. Uma tradição ininterrupta no Coliseu desde 1941 que faz sonhar - este ano, com bolas! - o público de todas as idades. Venha sonhar connosco!
                            </p>



                            <Grid container className={styles.Credits}>
                                <Grid item xs={12}>
                                    <div>
                                        <h5>História Original</h5>
                                        <p>Afonso Cruz</p>
                                    </div>
                                    <div>
                                        <h5>Encenação</h5>
                                        <p>Ana Luena</p>
                                    </div>
                                    <div>
                                        <h5>Música</h5>
                                        <p>Carlos Tê e Pedro Vidal</p>
                                    </div>
                                    <div className={styles.Actors}>
                                        <h5>Atores</h5>
                                        <p>Pedro Almendra</p>
                                        <p>Susana Madeira</p>
                                    </div>

                                </Grid>
                            </Grid>
                        </section>



                        <section className={styles.Sessions}>

                            <Separator title="SESSÕES" />

                            <Grid container justify="center" className={styles.SessionMonth}>
                                <Typography variant="RocGroteskRegular20">
                                    DEZEMBRO
                                </Typography>
                            </Grid>

                            <Grid container spacing={2} className={styles.SessionGrid}>
                                {decemberSessions.map(session =>
                                    <Session session={session} key={session.id} />
                                )}
                            </Grid>

                            <Grid container justify="center" className={styles.SessionMonth}>
                                <Typography variant="RocGroteskRegular20">
                                    JANEIRO
                                </Typography>
                            </Grid>

                            <Grid container spacing={2} className={styles.SessionGrid}>
                                {januarySessions.map(session =>
                                    <Session session={session} key={session.id} />
                                )}
                            </Grid>

                            <div className={styles.SignLanguage}>
                                <p>Sessões com Língua Gestual Portuguesa:</p>
                                <p>27 Dez 21H00 e 4 Jan 15H00</p>
                            </div>

                            <p>Bilhetes entre 10€ e 20€, à venda no Coliseu, Ticketline e locais habituais.</p>

                            <div className={styles.Discounts}>
                                <p>Descontos</p>
                                <p>75% crianças até aos 3 anos</p>
                                <p>50% crianças até aos 12 anos</p>
                                <p>20% Amigos do Coliseu e Cartão Porto</p>
                            </div>


                            <Grid container justify="center" className={styles.Call2Action}>
                                <Button onClick={handle} variant="outlined">
                                    Bilhetes
                                </Button>
                            </Grid>

                        </section>

                        <section className={styles.Artists}>

                            <Separator title="ARTISTAS" />

                            <Grid container className={styles.ArtistsContainer}>
                                {artists.map(artist =>
                                    <Artist artist={artist} key={artist.id} />
                                )}
                            </Grid>

                        </section>

                        <section className={styles.Gallery}>

                            <Separator title="GALERIA" />

                            <Grid container direction="row" justify="center">
                                <Grid item xs={12} lg={10}>
                                    <EventGallery photos={photos} hideTitle />
                                </Grid>
                            </Grid>
                        </section>

                        <section className={styles.Staff}>

                            <Separator title="FICHA TÉCNICA" />

                            <Grid container className={styles.TechTeam}>
                                <Grid item xs={12} md={6}>
                                    <div>
                                        <p><b>História</b> Afonso Cruz</p>
                                        <p><b>Encenação</b> Ana Luena</p>
                                        <p><b>Música</b> Carlos Tê e Pedro Vidal</p>
                                        <p><b>Desenho de Luz</b> Cárin Geada</p>
                                        <p><b>Operação de Som</b> Carlos Matos, Miguel Moreira, Miguel Silva</p>
                                        <p><b>Operação de Luz</b> José Cunha, Pedro Moreira</p>
                                        <p><b>Operação de followspot</b> António Alves, António Mota, Tiago Mota</p>
                                        <p><b>Assistência de Pista</b> Stay On the Scene</p>
                                        <p><b>Apoio à Produção</b> Luísa Teixeira</p>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div>
                                        <p><b>Atores</b> Pedro Almendra e Susana Madeira</p>
                                        <p><b>Palhaços</b> Datinelli Brothers</p>
                                        <p><b>Aros</b> Priscila Alves</p>
                                        <p><b>Trapézio Duo</b> Kimberly Bargenquast e Flynn Miller</p>
                                        <p><b>Roller-Skating</b> Beata Surmiak e Jamie Swan</p>
                                        <p><b>Hand Balancing</b> Duo Jordanella</p>
                                        <p><b>Pole Aéreo</b> Mateo Sito</p>
                                        <p><b>Funambulismo</b> Los Guerreros</p>
                                        <p><b>Fitas Aéreas</b> Agustin Rodriguez Beltran</p>
                                    </div>
                                </Grid>
                            </Grid>

                            <div className={styles.Performers}>
                                <p>
                                    <b>INTÉRPRETES (2.º ANO DE DANÇA DO BALLETTEATRO):</b> Afonso Pinhel, Ana Luiza Alves, Ana Rita Sá, Beatriz Ribeiro,
                                    Carolina Lopes, Gabriela Teixeira, Gonçalo Pereira, Iara Belo, Mafalda Silva, Mara Cruz, Maria Nazaré Marinho, Maria Pinto,
                                    Mariana Costa, Matilde Pereira, Renata Soares, Sara Oliveira, Telma Oliveira, Ana Filipa Rocha, Benedita Oliveira, Catarina Guimarães,
                                    Cátia Rodrigues, Francisca Pinto, Hugo Nascimento, Isabel Matos, Laura Moreira, Mafalda Macedo, Maria Jorge Fonseca, Mariana Silva,
                                    Marta Barbosa, Matilde Sousa, Ricardo Pereira, Sabrina Vásquez, Sofia Rocha, Leonor Truta
                                </p>
                            </div>

                            <div className={styles.Coordination}>
                                <p><b>COORDENAÇÃO GERAL:</b> Miguel Guedes</p>
                            </div>

                            <div className={styles.Team}>
                                <p>
                                    <b>Equipa Coliseu:</b> André Gonçalves, Artem Yakuni, Celestino Teixeira, Eduardo Amorim Cambra, Eduardo Cambra, Fátima Pinto,
                                    Fernando Mota, Filipa Godinho, Graça Barreto, Ivan Pinto, João Pereira, João Puig, José Carlos Pinto Coelho, José Cunha, Juliana Agostinho,
                                    Justina Vilela, Lara Jacinto, Leandro Couto, Luís Barros, Paulo Alves, Pedro Moreira, Sara Coelho, Tiago Azevedo
                                </p>
                            </div>

                        </section>

                        <section className={styles.Footer}>
                            <Grid container justify="center">
                                <img src={logos} alt="logotipos apoios" />
                            </Grid>
                        </section>
                    </div>
                </Grid>
            </>
        </PageTransition>
    )
}

